import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { NotificationStack } from 'react-notification'
import Immutable from 'seamless-immutable'
import _ from 'lodash'
import PropTypes from 'prop-types'

import styleguide from 'styleguide'
import { actionCreators } from 'reduxBits/notifications'

const baseStyle = Immutable.from({
  barStyle: {
    boxShadow: '0 1px 3px 2px rgba(88, 86, 85, 0.6)',
    fontFamily: styleguide.font.family.medium,
    fontSize: styleguide.font.size.small,
    borderRadius: '2px',
    padding: styleguide.padding.medium,
    marginRight: styleguide.padding.medium,
    zIndex: '4000',
  },
  actionStyle: {
    float: 'right',
    fontFamily: styleguide.font.family.regular,
    color: styleguide.color.white,
    fontSize: styleguide.font.size.xSmall,
    lineHeight: null,
  },
})

const styles = Immutable.from({
  error: _.merge({}, baseStyle, {
    barStyle: {
      background: styleguide.color.black,
    },
  }),
  success: _.merge({}, baseStyle, {
    barStyle: {
      background: styleguide.color.green,
    },
  }),
})

const mapStateToProps = (state) => ({
  notifications: state.notifications.notifications,
})

const attachStylesAndHandlers = (n, actions) => ({
  ...n,
  ...styles[n.type],
  onClick: ({ key }, deactivate) => {
    deactivate()
    actions.removeNotification(key)
  },
})
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})

export const _Notifications = ({ actions, notifications }) => (
  <NotificationStack
    notifications={notifications.map((n) => attachStylesAndHandlers(n, actions))}
    onDismiss={({ key }) => actions.removeNotification(key)}
  />
)

_Notifications.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  notifications: PropTypes.array.isRequired,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(_Notifications)
